/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import Text from '../Text/Text';
import Statement from '../Statement/Statement';
import './StatementText.scss';

interface StatementTextProps {
  statement?: string;
  text?: string;
  dropcap?: boolean;
}

/**
 * This is the StatementText component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function StatementText({
  statement,
  text,
  dropcap = false,
}: StatementTextProps) {
  return (
    <div className="block statement-text">
      <Text dropcap={dropcap}>{text}</Text>
      <Statement>{statement}</Statement>
    </div>
  );
}

export default StatementText;
